import React from "react";

interface SelectedTagsProps {
  label?: string;
  selectedItems: { value: string; label: string }[];
  onRemove: (value: string) => void;
  className?: string;
}

export default function SelectedTags({ label, selectedItems, onRemove, className = "" }: SelectedTagsProps) {
  return (
    <div className={className}>
      {label && <p className="text-sm text-gray-500 mb-2">{label}</p>}
      <div className="flex flex-wrap gap-2">
        {selectedItems.map(item => (
          <div
            key={item.value}
            className="inline-flex items-center gap-2 px-2 py-1 rounded-full bg-[#F1F8E6] text-[#4D7311] text-[12px]"
          >
            <span className="leading-none">{item.label}</span>
            <button
              type="button"
              onClick={() => onRemove(item.value)}
              className="text-[#4D7311] hover:text-[#4D7311] focus:outline-none text-lg leading-none flex items-center "
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
